import "./components";

$(function () {
    $(document).on("click", ".add_to_favorite", function (event) {
        event.preventDefault();
        const _self = $(this);
        const box = _self.closest('.bv_data');
        const id = box.data('id');

        $.post('/ajax/add_to_favorite', {id: id}, function (result) {
            let data = JSON.parse(result);
            if (data.action === 'add') {
                _self.addClass('active');
            } else {
                _self.removeClass('active');
                if (_self.hasClass('delete_favorite')) {
                   box.remove();
                }
            }
        });
    });

    $(document).on("click", ".add_to_cart", function (event){
        event.preventDefault();
        const box = $(this).closest('.bv_data');
        const id = box.data('id');

        $.post("/cart/add", {id: id, qty:1, change:false}, function (result) {
            let data = JSON.parse(result);
            if(data.code === 200) {
                $(".cart__dropdown").html(data.view);
                $(".ajax__total").text(data.total);
            }
        });
    });

    $(document).on("click", ".minus, .plus", function () {
        const box = $(this).closest('.bv_data');
        const id = box.data('id');
        const qty = box.find("input").val();

        if(qty < 1) return false;

        $.post("/cart/add", {id: id, qty:qty, change:true}, function (result) {
            let data = JSON.parse(result);
            if(data.code === 200) {
                $(".cart__dropdown").html(data.view);
                $(".ajax__total").text(data.total);
                $('[data-key="' + data.key + '"]').text(data.iTotal);
            }
        });
    });

    $(document).on("click", ".nav__header-cart", function (event) {
        if ($(event.target).parents('.cart__dropdown').length === 0) {
            $(".cart__dropdown").toggle();
        }
    });
});
